module.exports = __webpack_public_path__ + "static/media/33000143.86300012.png";